import { useMutation } from 'react-query';
import { INIT_UI_LANGUAGE } from 'constants/languages';
import apiCubic from 'config/api-cubic';
import { wait } from 'utils/requester';

export const KEY = 'USE_CHANGE_MAIN_PACKAGE';

const call = async ({ contractCode, pkg }) => {
  const data = await apiCubic.post({
    endpoint: apiCubic.endpoints.buyMainSubscription,
    data: { contractCode, tmCode: pkg.id, language: INIT_UI_LANGUAGE },
  });

  if (data.error) {
    const error = new Error(data.error.message);
    error.code = data.error.code;
    throw error;
  }
  // https://hootko.atlassian.net/browse/STVWL-554
  await wait(7000);

  return data;
};

export const useChangeMainPackage = (options = {}) => {
  return useMutation(call, { mutationKey: KEY, ...options });
};

export default useChangeMainPackage;
